/**
 * Check permission of user
 * 
 * @param {type} userId
 * @param {type} path
 * @returns {Boolean} 
 */
const HasPermission = async (path) => {
    const user = await axios.post('/api/users/permission', {path: path});
    if (user.status === 200) {
        return user.data;
    }
    return false;
};
export default HasPermission;
